/** Do → Si♭: paleta legible sobre fondo oscuro (canciones / teclado). */
export const PITCH_CLASS_COLORS: readonly string[] = [
  "#F472B6", // C
  "#FB923C", // C#
  "#FACC15", // D
  "#A3E635", // D#
  "#34D399", // E
  "#2DD4BF", // F
  "#38BDF8", // F#
  "#818CF8", // G
  "#A78BFA", // G#
  "#E879F9", // A
  "#F87171", // A#
  "#FB7185", // B
];

export function pitchClassFromMidi(midi: number): number {
  return ((Math.round(midi) % 12) + 12) % 12;
}

export function pitchClassColor(midiOrPc: number): string {
  return PITCH_CLASS_COLORS[pitchClassFromMidi(midiOrPc)] ?? PITCH_CLASS_COLORS[0];
}
